import {GET} from './fetcher';

export async function query_balance({queryKey}: {queryKey: [string, string]}): Promise<{exchange: string; ticker: string; balance: number}> {
	const exchange_ticker = queryKey[1];
	const exchange = exchange_ticker.split('/')[0];
	const ticker = exchange_ticker.split('/')[1];

	const resp = await GET(`/v1/account/balance?exchange=${exchange}&ticker=${ticker}`);

	return {
		exchange: resp.data.exchange,
		ticker: resp.data.ticker,
		balance: Math.floor(parseFloat(resp.data.balance)),
	};
}

export async function request_ping() {
	const resp = await GET('/ping');
	return resp;
}
